module.exports = __webpack_public_path__ + "img/icon-hospital.7fbf917e.png";